import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { endpoints } from '../../utils/endpoints';
import {
    SearchForPlayersResponse,
    SearchForTeamsResponse,
    SupervisorSearchItem,

} from '../models/common.interface';

@Injectable({
    providedIn: 'root',
})
export class CommonService {
    private http = inject(HttpClient);


    searchForPlayers(search: {
        query: string;
        page: number;
        pageSize: number;
    }) {
        let query = new HttpParams();
        query = query.append('Filters', `Nickname@=*${search.query}`);
        query = query.append('Page', search.page);
        query = query.append('PageSize', search.pageSize);

        return this.http.get<SearchForPlayersResponse>(
            endpoints.userProfile.children.searchPlayers(),
            {
                params: query,
            }
        );
    }

    searchForTeams(search: { query: string; page: number; pageSize: number }) {
        let query = new HttpParams();
        query = query.append('Filters', `Name@=*${search.query}`);
        query = query.append('Page', search.page);
        query = query.append('PageSize', search.pageSize);

        return this.http.get<SearchForTeamsResponse>(
            endpoints.teams.children.getTeams(),
            {
                params: query,
            }
        );
    }

    setRefCode(refCode: string,firstAccessTimestamp: string) {
        return this.http.post(
            endpoints.userProfile.children.setRefCode(),
            {refCode,firstAccessTimestamp}
        )
    }

    searchForSupervizer(search: {
        query: string;
        page: number;
        pageSize: number;
    }) {

        return this.http.get<SupervisorSearchItem[]>(
            endpoints.permissions.children.getUsersByPermission(search.query)
        )
    }
}
